import {
  formatApZonedDate,
  formatApZonedDateTime,
} from "@/accounts-payable/utils";
import { useApBusinessTimeZone } from "./use-ap-business-time-zone";

/**
 * When a document reached Volca, read in the business's time zone: the day,
 * or with `withTime` the day, time and zone. The day alone carries the full
 * timestamp as a tooltip.
 */
export const AddedDate = ({
  value,
  withTime = false,
}: {
  value: string | null | undefined;
  withTime?: boolean;
}) => {
  const timeZone = useApBusinessTimeZone();
  const full = formatApZonedDateTime(value, timeZone);
  if (withTime) return <span>{full ?? "—"}</span>;
  return <span title={full}>{formatApZonedDate(value, timeZone)}</span>;
};
